import {Button, Dialog, DialogBody, DialogFooter, DialogHeader, Input, Typography} from "@material-tailwind/react";
import React, {useState} from "react";
import "../../style/datePicker.css"
import {BsUpload} from "react-icons/bs";
import {updateProfilePhoto} from "../../services/profile/profile";

export function ProfilePhoto({modalOpen, setModalOpen, src, setPhoto}) {
  const handleOpen = () => setModalOpen(!modalOpen);

  const avatar = '/assets/blank_profile.jpg';

  const [srcPhoto, setSrcPhoto] = useState(src)
  const [file, setFile] = useState("")
  const [fileName, setFileName] = useState("")

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFile(file)
    setFileName(file.name);
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setSrcPhoto(reader.result); // Set the image preview source
      };
      reader.readAsDataURL(file); // Read the image file as a data URL
    }
  };

  const save = async () => {
    const data = {
      photo: file
    }

    let result;

    result = await updateProfilePhoto(data)
    if (result.status === 200) {
      const {photo} = result.data;

      handleOpen()
      setPhoto(photo)
      const userInfo = JSON.parse(localStorage.getItem('userInfo'))
      userInfo.photo = photo
      localStorage.setItem('userInfo', JSON.stringify(userInfo))
    }
  }

  return (
    <>
      <Dialog open={modalOpen} handler={handleOpen} animate={{mount: {scale: 1, y: 0}, unmount: {scale: 0.9, y: -100}}}>
        <DialogHeader className="border-b">
          <Typography>تصویر پروفایل</Typography>
        </DialogHeader>
        <DialogBody className="flex flex-col items-center gap-4 overflow-y-scroll">
          {srcPhoto &&
            <img
              className="h-96 w-96 rounded-full object-cover object-center"
              src={srcPhoto ? srcPhoto : avatar}
              alt="nature image"
            />
          }
          <div className={`flex pl-4 items-center justify-center w-full`}>
            <label htmlFor={0}
                   className="relative cursor-pointer align-middle select-none font-sans font-bold text-center uppercase transition-all disabled:opacity-50 disabled:shadow-none disabled:pointer-events-none text-xs py-3 px-4 rounded-lg border border-gray-900 text-gray-900 hover:opacity-75 focus:ring focus:ring-gray-300 active:opacity-[0.85] flex-shrink-0">
              <div className="flex flex-row">
                <BsUpload size={16} fontSize="sm"/>
                <div className="mr-2">
                  انتخاب تصویر
                </div>
              </div>

              <input id={0} type="file" className="hidden" onChange={handleFileChange}/>
            </label>
            <Input className="mx-4" variant="standard" readOnly={true} value={fileName}/>

          </div>
        </DialogBody>
        <DialogFooter className="space-x-2">
          <Button variant="gradient" color="gray" className="ml-1" onClick={save}>
            <span>ذخیره</span>
          </Button>
          <Button variant="text" color="gray" onClick={handleOpen}>
            <span>انصراف</span>
          </Button>
        </DialogFooter>
      </Dialog>
    </>
  );
}